import React from 'react'
import { Tabs, Tab } from 'react-bootstrap'

import ChartsList from './ChartsList'

const ValidationCharts = (props) => {
	const {
		routerProps,
		charts,
	} = props

	return (
		<Tabs defaultActiveKey="requires_data_manager_validation">
			{/* <Tab eventKey="requires_adr_validation" title="Requires ADR Validation">
				<ChartsList
					title="Requires ADR Validation"
					routerProps={routerProps}
          charts={charts['requires_adr_validation'] || []}
				/>
			</Tab> */}

			<Tab eventKey="requires_data_manager_validation" title="Requires Data Manager Validation">
				<ChartsList
					title="Requires Data Manager Validation"
					routerProps={routerProps}
					charts={charts['requires_data_manager_validation'] || []}
				/>
			</Tab>
		</Tabs>
	)
}


export default ValidationCharts
